import { ReactComponent as ReactLogo } from '../../../assets/infoIcon.svg'

interface Props {
    onClick: () => void
    disabled?: boolean
}

const ButtonOrderDetailInProcessNavigation = ({ onClick, disabled = false }: Props) => {
    return (
        <ReactLogo
            className={`cursor-pointer ${disabled ? 'opacity-50 pointer-events-none' : ''}`}
            onClick={disabled ? undefined : onClick}
        />
    )
}
export default ButtonOrderDetailInProcessNavigation
